import React, { FC } from "react";
import { sendChatMessage } from "../../../api-queries/GraohQlClient";
import { IArtwork } from "../../../types/artwork/artwork";
import { generateArtworkRequestMessage } from "../../../utils/generateArtworkRequestMessage";
import AskingModal from "../AskingModal/AskingModal";

interface IOfferModalProps {
  close: () => void;
  isOpen: boolean;
  artwork: IArtwork;
  artworkId: string | undefined;
}

const OfferModal: FC<IOfferModalProps> = ({ close, isOpen, artwork, artworkId }) => {
  const currentArtworkOwner = artwork.collector || artwork.owner;

  const requestPurchase = async (text: string): Promise<void> => {
    const messageText = `New offer: \n${generateArtworkRequestMessage(artwork, text)}`;
    const message = {
      text: messageText,
      recipientId: currentArtworkOwner._id,
      audited: {
        artwork: artworkId,
      },
      imagesOfChat: [],
    };
    try {
      await sendChatMessage(message);
    } catch (error) {
      console.log(error);
    }
    close();
  };

  return (
    <AskingModal
      close={close}
      isOpen={isOpen}
      artwork={artwork}
      action={requestPurchase}
      buttonText="MAKE AN OFFER"
      modalTitle="Make an offer"
    />
  );
};

export default OfferModal;
